export function toAgriKML(data) {
  // 이미 KML인지 체크 (재귀 호출 방지)
  if (typeof data === "string" && data.includes("<?xml")) {
    return data; // 이미 KML이면 그대로 반환
  }

  // 경로 좌표를 KML 형식으로 변환 (lon,lat,alt 형식)
  const pathCoordinates =
    data.waypointDetails?.map((p) => `${p.x},${p.y},${p.z}`).join(" ") || "";

  // 장애물 좌표를 KML 형식으로 변환
  const obstacleElements =
    data.obstacles
      ?.map((obs) => {
        const obstacleCoordinates = obs.points
          .map((pt) => `${pt.x},${pt.y},${pt.z}`)
          .join(" ");

        return `<Placemark>
      <name>${obs.name || "장애물"}</name>
      <description>
        <![CDATA[
          <b>타입:</b> ${obs.areaType?.typeName || "N/A"}<br/>
          <b>설명:</b> ${obs.description || "N/A"}<br/>
          <b>ID:</b> ${obs.id}
        ]]>
      </description>
      <ExtendedData>
        <Data name="type">
          <value>OBSTACLE</value>
        </Data>
        <Data name="obstacleId">
          <value>${obs.id}</value>
        </Data>
        <Data name="areaTypeId">
          <value>${obs.areaType?.id || ""}</value>
        </Data>
        <Data name="areaTypeName">
          <value>${obs.areaType?.typeName || ""}</value>
        </Data>
        <Data name="areaTypeColor">
          <value>${obs.areaType?.typeColor || ""}</value>
        </Data>
      </ExtendedData>
      <Style>
        <PolyStyle>
          <color>80${(obs.areaType?.typeColor || "#FF0066").replace(
            "#",
            ""
          )}</color>
          <fill>1</fill>
          <outline>1</outline>
        </PolyStyle>
        <LineStyle>
          <color>ff${(obs.areaType?.typeColor || "#FF0066").replace(
            "#",
            ""
          )}</color>
          <width>2</width>
        </LineStyle>
      </Style>
      <Polygon>
        <extrude>1</extrude>
        <altitudeMode>absolute</altitudeMode>
        <outerBoundaryIs>
          <LinearRing>
            <coordinates>${obstacleCoordinates}</coordinates>
          </LinearRing>
        </outerBoundaryIs>
      </Polygon>
    </Placemark>`;
      })
      .join("") || "";

  return `<?xml version="1.0" encoding="UTF-8"?>
<kml xmlns="http://www.opengis.net/kml/2.2">
  <Document>
    <name>${data.name || "농기구 경로"}</name>
    <description>
      <![CDATA[
        <b>프로젝트 ID:</b> ${data.projectId}<br/>
        <b>경로 ID:</b> ${data.id}<br/>
        <b>작업 유형:</b> ${data.workType}<br/>
        <b>설명:</b> ${data.description || "N/A"}<br/>
        <b>생성일:</b> ${data.createdAt}<br/>
        <b>생성자:</b> ${data.createdByName}<br/>
        <br/>
        <b>농기구 정보:</b><br/>
        - 이름: ${data.agriculturalEquipmentName}<br/>
        - 폭: ${data.equipmentSpec?.width}m<br/>
        - 축간거리: ${data.equipmentSpec?.wheelbaseL}m<br/>
        - 최대 조향각: ${data.equipmentSpec?.steerDeg}°
      ]]>
    </description>
    
    <!-- 경로 스타일 정의 -->
    <Style id="pathStyle">
      <LineStyle>
        <color>ff00ffff</color>
        <width>4</width>
      </LineStyle>
      <PolyStyle>
        <color>7f00ff00</color>
      </PolyStyle>
    </Style>

    <!-- 경로 정보 -->
    <Placemark>
      <name>농기구 주행 경로</name>
      <description>
        <![CDATA[
          <b>경로 ID:</b> ${data.id}<br/>
          <b>웨이포인트 수:</b> ${data.waypointDetails?.length || 0}개<br/>
          <b>작업 유형:</b> ${data.workType}
        ]]>
      </description>
      <ExtendedData>
        <Data name="type">
          <value>PATH</value>
        </Data>
        <Data name="routeId">
          <value>${data.id}</value>
        </Data>
        <Data name="projectId">
          <value>${data.projectId}</value>
        </Data>
        <Data name="workType">
          <value>${data.workType}</value>
        </Data>
        <Data name="equipmentId">
          <value>${data.agriculturalEquipmentId}</value>
        </Data>
        <Data name="equipmentName">
          <value>${data.agriculturalEquipmentName}</value>
        </Data>
        <Data name="equipmentWidth">
          <value>${data.equipmentSpec?.width}</value>
        </Data>
        <Data name="equipmentWheelbase">
          <value>${data.equipmentSpec?.wheelbaseL}</value>
        </Data>
        <Data name="equipmentSteerDeg">
          <value>${data.equipmentSpec?.steerDeg}</value>
        </Data>
      </ExtendedData>
      <styleUrl>#pathStyle</styleUrl>
      <LineString>
        <extrude>1</extrude>
        <altitudeMode>absolute</altitudeMode>
        <coordinates>${pathCoordinates}</coordinates>
      </LineString>
    </Placemark>

    <!-- 장애물 정보 -->
    ${obstacleElements}
    
  </Document>
</kml>`;
}
